import { ArrowBack } from '@mui/icons-material'
import { Button } from '@mui/material'
import { ComponentProps } from 'react'

/**
 * ヘッダーで使用する「<-戻る」ボタン
 * MUI版
 */
export const HeaderBackButtonMui = (props: ComponentProps<typeof Button>) => {
  const { children = '戻る', ...restProps } = props
  return (
    <Button
      {...restProps}
      startIcon={<ArrowBack />}
      variant="text"
      color="primary"
      sx={{ flexShrink: 0, ...restProps.sx }}
    >
      {children}
    </Button>
  )
}
